<template>
  <div class="personal-center-container">
    <!-- 侧边栏 -->
    <div class="side-mb">
      <ul class="nav-side-mb">
        <li class="nav-group">
          <div class="nav-group-title">
            <i class="el-icon-user"></i>
            <span>个人中心</span>
          </div>
          <ul class="nav-group-items">
            <li :class="{ current: $route.name === 'Downloadlatest' }">
              <router-link :to="{ name: 'Downloadlatest' }">
                <i class="el-icon-download"></i>
                我的下载
              </router-link>
            </li>
            <li :class="{ current: $route.name === 'Mycollection' }">
              <router-link :to="{ name: 'Mycollection' }">
                <i class="el-icon-star-on"></i>
                我的收藏
              </router-link>
            </li>
            <li :class="{ current: $route.name === 'Messagecenter' }">
              <router-link :to="{ name: 'Messagecenter' }">
                <i class="el-icon-message"></i>
                消息中心
              </router-link>
            </li>
          </ul>
        </li>
        
        <li class="nav-group">
          <div class="nav-group-title">
            <i class="el-icon-setting"></i>
            <span>账户设置</span>
          </div>
          <ul class="nav-group-items">
            <li :class="{ current: $route.name === 'Perstion' }">
              <router-link :to="{ name: 'Perstion' }">
                <i class="el-icon-user-solid"></i>
                个人信息
              </router-link>
            </li>
            <li :class="{ current: $route.name === 'Chapassword' }">
              <router-link :to="{ name: 'Chapassword' }">
                <i class="el-icon-key"></i>
                修改密码
              </router-link>
            </li>
            <li :class="{ current: $route.name === 'Conversioncode' }">
              <router-link :to="{ name: 'Conversioncode' }">
                <i class="el-icon-tickets"></i>
                卡密绑定
              </router-link>
            </li>
          </ul>
        </li>
        
        <!-- 管理员功能 -->
        <li v-if="hasManagementFeatures" class="nav-group">
          <div class="nav-group-title">
            <i class="el-icon-s-tools"></i>
            <span>管理功能</span>
          </div>
          <ul class="nav-group-items">
            <li v-if="canAccessFileManagement" :class="{ current: $route.name === 'FileManagement' }">
              <router-link :to="{ name: 'FileManagement' }">
                <i class="el-icon-folder"></i>
                文件管理
              </router-link>
            </li>
            <li v-if="canAccessCategoryManagement" :class="{ current: $route.name === 'CategoryManagement' }">
              <router-link :to="{ name: 'CategoryManagement' }">
                <i class="el-icon-menu"></i>
                分类管理
              </router-link>
            </li>
            <li v-if="canAccessEcardManagement" :class="{ current: $route.name === 'EcardManagement' }">
              <router-link :to="{ name: 'EcardManagement' }">
                <i class="el-icon-tickets"></i>
                卡密管理
              </router-link>
            </li>
            <li v-if="canAccessCategoryManagement" :class="{ current: $route.name === 'BannerManagement' }">
              <router-link :to="{ name: 'BannerManagement' }">
                <i class="el-icon-picture"></i>
                轮播图管理
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    
    <!-- 主内容区域 -->
    <div class="main-mb">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { 
  isAdminLoggedIn,
  canAccessFileManagement,
  canAccessCategoryManagement,
  canAccessEcardManagement,
  getAccessibleManagementFeatures
} from '@/utils/adminAuth';

export default {
  name: 'Personalcenter',
  data() {
    return {
      hasManagementFeatures: false,
      canAccessFileManagement: false,
      canAccessCategoryManagement: false,
      canAccessEcardManagement: false
    };
  },
  beforeRouteEnter(to, from, next) {
    // 检查用户登录状态
    const hasToken = localStorage.getItem('token') || sessionStorage.getItem('token');
    const hasAdminToken = localStorage.getItem('admin_token');
    
    if (!hasToken && !hasAdminToken) {
      // 未登录，跳转到首页
      next({ name: 'indexPage' });
    } else {
      next();
    }
  },
  computed: {
    // 获取当前用户信息
    currentUserInfo() {
      return {
        canFileManage: this.$store.state.canFileManage,
        canUserManage: this.$store.state.canUserManage,
        canSystemManage: this.$store.state.canSystemManage,
        role: this.$store.state.role,
        vip: this.$store.state.vip,
        permissionLevel: this.$store.state.permissionLevel
      };
    }
  },
  methods: {
    // 初始化管理员状态 - 权限向上兼容版本
    initAdminStatus() {
      const userInfo = this.currentUserInfo;
      
      // 权限向上兼容：用户管理 > 系统管理 > 文件管理
      this.canAccessFileManagement = userInfo.canFileManage || userInfo.canUserManage || userInfo.canSystemManage;
      this.canAccessCategoryManagement = userInfo.canSystemManage || userInfo.canUserManage;
      this.canAccessEcardManagement = userInfo.canUserManage;
      
      // 检查是否有管理功能
      this.hasManagementFeatures = this.canAccessFileManagement || 
                                   this.canAccessCategoryManagement || 
                                   this.canAccessEcardManagement ||
                                   isAdminLoggedIn();
    },

    // 强制刷新管理员状态
    refreshAdminStatus() {
      // 重新初始化store中的用户数据
      this.$store.dispatch('initUserData');
      // 重新初始化管理员状态
      this.$nextTick(() => {
        this.initAdminStatus();
      });
    }
  },
  mounted() {
    // 页面加载时刷新管理员状态
    this.refreshAdminStatus();
    
    // 修复UI整体变大问题：确保浏览器缩放和字体大小正确初始化
    this.$nextTick(() => {
      // 重置可能的浏览器缩放问题
      if (document.body.style.zoom) {
        document.body.style.zoom = '1';
      }
      // 确保字体大小正确
      const htmlElement = document.documentElement;
      if (htmlElement.style.fontSize) {
        htmlElement.style.fontSize = '';
      }
      // 重置可能的transform scale
      if (htmlElement.style.transform) {
        const transform = htmlElement.style.transform;
        if (transform.includes('scale')) {
          htmlElement.style.transform = '';
        }
      }
    });
  },
  watch: {
    // 监听store状态变化
    '$store.state': {
      handler() {
        this.initAdminStatus();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.personal-center-container {
  display: flex;
  min-height: 80vh;
  background: #f5f6fa;
  border-radius: 6px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.06);
  overflow: hidden;
  width: 100%;
  margin-right: 15%;
}

.side-mb {
  width: 280px;
  background: #fff;
  border-right: 1px solid #f0f0f0;
  box-shadow: 2px 0 8px rgba(0,0,0,0.03);
  border-radius: 6px 0 0 6px;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  transition: box-shadow 0.3s;
}

.main-mb {
  flex: 1;
  background: #fff;
  border-radius: 0 6px 6px 0;
  padding: 40px 48px 48px 48px;
  min-height: 600px;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
}

.nav-side-mb {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.nav-group {
  margin-bottom: 24px;
}

.nav-group-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  padding: 12px 24px 8px 24px;
  margin-bottom: 4px;
  background: #fafbfc;
  border-left: 3px solid #f1787f;
  border-radius: 0 6px 6px 0;
}

.nav-group-title i {
  font-size: 18px;
  margin-right: 10px;
  color: #f1787f;
}

.nav-group-items {
  list-style: none;
  padding: 0;
  margin: 0;
  padding-left: 20px;
}

.nav-group-items li {
  margin-bottom: 4px;
}

.nav-group-items li a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-radius: 6px;
  color: #555;
  font-size: 14px;
  transition: all 0.2s ease;
  cursor: pointer;
  text-decoration: none;
  position: relative;
  margin-left: 8px;
}

.nav-group-items li a i {
  margin-right: 10px;
  font-size: 16px;
  width: 16px;
  text-align: center;
  color: #888;
  transition: color 0.2s ease;
}

.nav-group-items li a:hover {
  background: #f5e9ea;
  color: #f1787f;
  transform: translateX(4px);
}

.nav-group-items li a:hover i {
  color: #f1787f;
}

.nav-group-items li.current > a {
  background: #f1787f;
  color: #fff;
  font-weight: 600;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(241, 120, 127, 0.3);
  transform: translateX(4px);
}

.nav-group-items li.current > a i {
  color: #fff;
}

.nav-group-items li.current > a::before {
  content: '';
  position: absolute;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: #f1787f;
  border-radius: 2px;
}

@media (max-width: 900px) {
  .personal-center-container {
    flex-direction: column;
    max-width: 100vw;
    margin: 0;
    border-radius: 0;
    box-shadow: none;
  }
  
  .side-mb {
    width: 100%;
    border-radius: 0;
    box-shadow: none;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding: 16px 0;
    min-height: unset;
  }
  
  .main-mb {
    border-radius: 0;
    padding: 24px 16px;
    min-height: 400px;
  }
  
  .nav-group {
    margin-bottom: 16px;
  }
  
  .nav-group-title {
    padding: 10px 16px 6px 16px;
    font-size: 15px;
  }
  
  .nav-group-items {
    padding-left: 16px;
  }
  
  .nav-group-items li a {
    padding: 10px 16px;
    font-size: 13px;
    margin-left: 4px;
  }
  
  .nav-group-items li a:hover,
  .nav-group-items li.current > a {
    transform: translateX(2px);
  }
}
</style>
